export const EVENT_FEEDBACK_RESPONSE_MODAL_TEXT =
  'Thanks for attending this event! Please share feedback on your experience.';

export const ZOOM_REINTEGRATION_ERROR = 'ZOOM_REINTEGRATION_NEEDED';
export const MEET_REINTEGRATION_ERROR = 'MEET_REINTEGRATION_NEEDED';

export const DEFAULT_LINK_GENERATION_ERROR = "Default Link couldn't be generated. Try again later.";

export const ZOOM_SYNC_FAILED_ERROR =
  "Event saved, but its Zoom meeting wasn't updated. Check your Zoom connection, or remove and re-add the Zoom link.";

export const INVALID_EMAIL_QUERY = 'invalidEmailModal';

export const PERMISSIONS_DENIED_QUERY = 'permissionsDenied';

export const EVENT_FULL_ERROR = 'This event is full';
